import React, { useState, useEffect, useContext, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Text from '../../Datatypes/Text';
import Select from '../../Datatypes/Select';
import MultiSelect from '../../Datatypes/MultiSelect';
import Checkbox from '../../Datatypes/Checkbox';
import Stars from '../../Datatypes/Stars';
import Contact from '../../Datatypes/Contact';
import User from '../../Datatypes/User';
import Lookup from '../../Datatypes/Lookup';
import { ObjModal } from '../../../../contexts';


const SectionV2 = ( { title, body, id = 'gen', gPick, lists } ) => {
    const [ expanded, setExpanded ] = useState( true );
    const [ picklists, setPicklists ] = useState( {} );
    const { obj, oid, objPick } = useContext( ObjModal );

    useEffect( () => {
        console.log( 'in v2!' );
    }, [] );

    useEffect( () => {
        console.log( 'body: ', body );
    }, [ body ] );

    useEffect( () => {
        let list = {};
        Object.keys( gPick ).forEach( l => {
            if ( typeof gPick[l] === 'object' ) {
                list[l] = [ ...gPick[l] ];
            } else if ( typeof gPick[l] === 'string' ) {
                list[l] = [ ...gPick[gPick[l]] ];
            }
        } );
        Object.keys( objPick ).forEach( l => {
            if ( typeof objPick[l] === 'object' ) {
                list[l] = [ ...objPick[l] ];
            } else if ( typeof objPick[l] === 'string' ) {
                list[l] = [ ...gPick[objPick[l]] ];
            }
        } );
        setPicklists( { ...list } );
    }, [ gPick, objPick ] );

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    const renderDataType = ( field ) => {
        let el = null;
        let disabled = ( field.disabled ) ? true : false;

        switch ( field.type ) {
            case 'text':
            case 'date':
            case 'email':
            case 'phone':
            case 'url':
            case 'textarea':
                el = <Text label={field.label} db={field.db} value={obj.details[field.db]} type={field.type} disabled={disabled} formId={id} />;
                break;

            case 'select':
                el = <Select label={field.label} db={field.db} value={obj.details[field.db]} options={picklists} bucket={obj.details['status']} formId={id} />;
                break;

            case 'multiselect':
                el = <MultiSelect label={field.label} db={field.db} value={obj.details[field.db]} options={picklists} bucket={obj.details['status']} formId={id} />;
                break;

            case 'checkbox':
                el = <Checkbox label={field.label} db={field.db} value={obj.details[field.db]} formId={id} />;
                break;

            case 'stars':
                el = <Stars label={field.label} db={field.db} value={obj.details[field.db]} formId={id} />;
                break;

            case 'contact':
                el = <Contact label={field.label} db={field.db} value={obj.details[field.db]} formId={id} aid={obj.details.aid} />;
                break;

            case 'user':
                el = <User label={field.label} db={field.db} value={obj.details[field.db]} ul={lists.team} formId={id} />;
                break;

            case 'lookup':
                el = <Lookup label={field.label} db={field.db} related={field.obj} formId={id} />
                break;

            default:
                if ( field.db ) {
                    el = <Col className='tf-obj-data-element'>{field.label}: {obj.details[field.db]}</Col>;
                } else {
                    el = <Col className='tf-obj-data-element'>&nbsp;</Col>;
                }
        }
        
        return el;
    }

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>{title}</Typography></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                        <ListGroup.Item className='border-0 py-0'>
                            {
                                body.map( ( b, idx ) => {
                                    if ( b.columns.length ) {
                                        return (
                                            <Fragment key={`row-${idx}`}>
                                                {
                                                    ( b.subtitle ) ? (
                                                        <Row className='px-0 py-3'>
                                                            <Col className='px-0 tf-section-subtitle'>{b.subtitle}</Col>
                                                        </Row>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Row className='align-items-start'>
                                                    {
                                                        b.columns.map( ( col, idx2 ) => {
                                                            return ( 
                                                                <Col key={`col-${idx}-${idx2}`} xs={b.columns.length >= 3 ? 'auto' : undefined}>
                                                                {
                                                                    col.map( ( field, idx3 ) => {
                                                                        let show = true;
                                                                        if ( field.conditional ) {
                                                                            console.log( 'cond: ', field.conditional );
                                                                            switch ( field.conditional.operator ) {
                                                                                case 'valid':
                                                                                    console.log( obj.details[field.conditional.db] );
                                                                                    show = ( obj.details[field.conditional.db] !== undefined );
                                                                                    break;

                                                                                case 'logic':
                                                                                    console.log( 'evaluating: ', field.conditional.logic );
                                                                                    show = eval( field.conditional.logic );
                                                                                    break;

                                                                                default:
                                                                                    show = ( obj.details[field.conditional.db] === field.conditional.value );
                                                                            }
                                                                        }
                                                                        if ( show ) {
                                                                            const key = ( field.db ) ? field.db : idx3;
                                                                            return <Row key={`${oid}-${id}-${key}`}><Col>{renderDataType( field )}</Col></Row>;
                                                                        }
                                                                        return null;
                                                                    } )
                                                                }
                                                                </Col> 
                                                            )
                                                        } )
                                                    }
                                                </Row>
                                            </Fragment>
                                        )
                                    }
                                    return <Row key={`row-${idx}`} className='align-items-start'><Col>&nbsp;</Col></Row>;
                                } )
                            }
                        </ListGroup.Item>
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    gPick: state.user.meta.global.picklist,
    lists: state.user.lists
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( SectionV2 );